import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { AccountFilterComponent } from '../../../_shared/components/filters/account-filter/account-filter.component';
import { SearchComponent } from '../../../_shared/components/filters/search/search.component';
import { AccountFilterData } from '../../../_shared/models/filters/widget-filter-data.model';
import { MaintenanceSettingsTab } from './enums/maintenance-settings.enum';
import { MaintenanceConfigurationComponent } from './components/maintenance-configuration/maintenance-configuration.component';
import { AddWorkshopsComponent } from './components/add-workshops/add-workshops.component';
import { BackButtonComponent } from '../../../_shared/components/back-button/back-button.component';

@Component({
  selector: 'app-maintenance-settings',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoDirective,
    AccountFilterComponent,
    SearchComponent,
    MaintenanceConfigurationComponent,
    AddWorkshopsComponent,
    BackButtonComponent
  ],
  templateUrl: './maintenance-settings.component.html',
  styleUrl: './maintenance-settings.component.scss'
})
export class MaintenanceSettingsComponent {
  @ViewChild('workshopsRef') workshopsRef!: AddWorkshopsComponent;

  accountFilter: AccountFilterData = {} as AccountFilterData;
  activeTab: MaintenanceSettingsTab = MaintenanceSettingsTab.MaintenanceConfiguration;
  maintenanceSettingsTab = MaintenanceSettingsTab;
  workshopSearchTerm: string = '';

  isTabActive(tab: MaintenanceSettingsTab): boolean {
    return this.activeTab === tab;
  }

  onTabChange(tab: MaintenanceSettingsTab): void {
    if (this.activeTab !== tab) {
      this.activeTab = tab;
    }
  }

  onAccountFilterChange(filter: AccountFilterData): void {
    this.accountFilter = { ...filter };
  }

  onWorkshopSearch(term: string): void {
    this.workshopSearchTerm = term;
  }

  onAddWorkshop(): void {
    this.workshopsRef?.onAddNew();
  }
}